export default {
  // common
  'extractor.common.upload': '点击上传文件',
  'extractor.common.try': '试一试：',
  'extractor.home': '首页',
  'extractor.button.download': '下载',
  'extractor.button.fullScreen': '全屏',
  'extractor.button.exitFullScreen': '退出全屏',
  'extractor.button.showLayer': '显示识别结果',
  'extractor.button.hiddenLayer': '隐藏识别结果',
  'extractor.button.reUpload': '重新上传',
  'extractor.error': '提取失败',
  'extractor.common.loading': '加载中',
  'extractor.law':
    '请确保您上传的文件合法合规，我们不承担因文件内容产生的法律责任。《信息保护政策》 《儿童信息保护政策》《服务协议》|© All Rights Reserved.沪ICP备2021009351号-21',
  'extractor.failed': '不可提取，暂无可展示数据',
  'extractor.common.extracting': '提取中，请稍等',
  'extractor.common.extracting.queue': '正在排队提取，当前排在第 {id} 位',
  'extractor.common.pdf.demo1': '示例1.pdf',
  'extractor.common.pdf.demo2': '示例2.pdf',
  'extractor.common.formula.detect.demo1': '公式检测1.jpg',
  'extractor.common.formula.extract.demo1': '公式识别1.jpg',
  'extractor.common.login.desc': '登录后可使用完整功能',

  // md
  'extractor.markdown.preview': '预览',
  'extractor.markdown.code': '代码',

  // home
  'extractor.home.title': '欢迎使用 Miner U',
  'extractor.home.subTitle': '上传文档，智能提取为 Markdown 格式',

  'extractor.side.extractTask': '提取任务',
  'extractor.side.extractTask.title': '请上传 50M 以内的 PDF 文档 （ 100 页以内）或 JPG/PNG 图片',

  // pdf
  'extractor.pdf.title': 'PDF文档提取',
  'extractor.pdf.subTitle': '支持文本/扫描型 PDF 解析，识别各类版面元素并转换为多模态 Markdown 格式',
  'extractor.common.pdf.upload.tip': '请上传 50M 以内，不超过 100 页的PDF文档',
  'extractor.pdf.ocr': 'OCR 识别模式',

  'extractor.pdf.ocr.popover':
    '  默认将自动识别PDF类型（文本型、扫描型），并根据识别结果选择采用文本识别或者OCR识别方式。 如开启，将对所有类型PDF采用OCR识别方式。',

  // formula
  'extractor.formula.title': '定位图片中的行内、行间公式，生成边界框',
  'extractor.formula.title2': '将图片中的数学公式识别为 laTex 格式，支持多行公式、手写公式识别',
  'extractor.formula.upload.text': '点击上传图片',
  'extractor.formula.popover.extract': '为获得最佳的公式识别效果，请上传清晰、无水印的包含数学公式的图片，如下图',
  'extractor.formula.popover.detect':
    '为获得最佳的公式识别效果，请裁剪图片，聚焦公式部分，上传清晰、无水印的数学公式图片，如下图',
  'extractor.formula.upload.accept': '请上传 5M 以内的JPG/PNG 图片',
  'extractor.formula.upload.try': '请上传包含数学公式的图片 示例：',

  // guide
  'extractor.guide.title': '欢迎使用更多开源产品 🎉',

  // queue
  'extractor.queue': '提取记录',
  'extractor.queue.delete': '确认删除此文件？',
  'extractor.queue.extracting': '提取中',

  // feedback
  'extractor.feedback.title1': '您对整体提取效果是否满意 ？',
  'extractor.feedback.title3': '期待您的建议，帮助我们更好的优化',
  'extractor.feedback.up.title': '您期望看到哪些改进？',
  'extractor.feedback.down.title': '您感到不满意的原因是？',
  'extractor.feedback.up': '满意',
  'extractor.feedback.down': '不满意',
  'extractor.feedback.input.placeholder': '请输入您的改进建议',
  'extractor.feedback.input.submit': '提交',
  'extractor.feedback.success': '感谢你的反馈',

  'mineru.docs.tab1': 'API 文档',
  'mineru.docs.tab2': 'API Tokens',
  'mineru.docs.tab3': '限流策略',
  'mineru.docs.tab4': '使用明细',
  'mineru.docs.api.token.title':
    'Token 将用于验证您调用MinerU API 时的账户身份。请妥善保管你的 API 不要将它暴露在浏览器或者其他客户端的代码中。API当前处于试运行测试阶段，有问题请及时联系运营反馈',
  'mineru.docs.api.token.title2': '注意所有 API Tokens 都遵从 MinerU API  的{limit}。',
  'mineru.docs.api.token.limit': '限流策略',
  'mineru.docs.api.token.deleteConfirmTitle': '确认删除此 API Token？',
  'mineru.docs.api.token.deleteConfirmContent': '删除后将无法使用此 API Token 调用 MinerU API',
  'mineru.docs.api.token.delete': '删除',
  'mineru.docs.api.token.name': '名称',
  'mineru.docs.api.token.token': 'Token',
  'mineru.docs.api.token.status': '状态',
  'mineru.docs.api.token.readWrite': '读写',
  'mineru.docs.api.token.expired': '已过期',
  'mineru.docs.api.token.createdAt': '创建时间',
  'mineru.docs.api.token.expiredAt': '过期时间',
  'mineru.docs.api.token.permission': '权限',
  'mineru.docs.api.token.create': '创建 API Token',
  'mineru.docs.api.token.actions': '操作',
  'mineru.docs.api.token.create.warning':
    '为了保证您的数据安全，点击确认后您不再可见此 API Token，请妥善保管此 API Token。如果不小心丢失，需要重新生成新的 API Token',
  'mineru.docs.api.token.name.placeholder': '请输入中文、英文、数字或字符',

  'mineru.api.apply.title': 'MinerU API 申请问卷（内测）',
  'mineru.api.apply.subTitle':
    '欢迎申请 MinerU 的 API 服务！请先填写并提交此申请表单。若审核通过后，我们将通过邮件引导您如何使用。当前 API 尚处于测试阶段，可能有不稳定情况，如有任何问题或建议，请及时联系我们。感谢支持！ 🙌',
  'mineru.api.apply.userType': '您是个人用户还是企业用户？',
  'mineru.api.apply.userType.personal': '个人用户',
  'mineru.api.apply.userType.enterprise': '企业用户',
  'mineru.api.apply.cooperation': '您是否愿意参与我们的数据合作',
  'mineru.api.apply.cooperation.yes': '是',
  'mineru.api.apply.cooperation.no': '否',
  'mineru.api.apply.companyName': '您的公司名称',
  'mineru.api.apply.fileCount': '您有多少待转换的PDF 文件',
  'mineru.api.apply.fileSize': '单份PDF文件大小是多少？（单位：GB）',
  'mineru.api.apply.provideMethod': '您希望提供数据的途径？',
  'mineru.api.apply.provideMethod.disk': '硬盘邮寄',
  'mineru.api.apply.provideMethod.webLink': '网盘链接',
  'mineru.api.apply.provideMethod.ftp': 'FTP传输',
  'mineru.api.apply.provideMethod.api': 'API 传输',
  'mineru.api.apply.provideMethod.other': '其他',
  'mineru.api.apply.otherMethod': '请问您的其他提供方式',
  'mineru.api.apply.email': '请问您的邮箱地址',
  'mineru.api.apply.email.invalid': '请输入正确的邮箱地址',
  'mineru.api.apply.phone': '请问您的电话是',
  'mineru.api.apply.phone.invalid': '请输入正确的电话号码',
  'mineru.api.apply.wechat': '请问您的微信是',
  'mineru.api.apply.openQuestion': '您对我们的 PDF 合作项目还有哪些建议或疑问',
  'mineru.docs.api.token.name.required': 'API Token 名称不能为空',
  'mineru.docs.api.token.saveWarning':
    '为了保证您的数据安全，点击确认后您不再可见此 API Token，请妥善保管此 API Token。如果不小心丢失，需要重新生成新的 API Token',
  'mineru.docs.api.token.saveTitle': '保存 API Token',
  'mineru.docs.api.token.create.limit': '当前最多可创建 5 个 API Token, 请删除后重新创建',

  'extractor.dataProcess.mineru.multiFormatExtract': '多格式提取：PDF、Word、PPT',
  'extractor.dataProcess.mineru.localDeploy': '本地部署',
  'extractor.dataProcess.mineru.onlineExplore': '在线体验',
  'extractor.dataProcess.mineru.apiApply': 'API 申请',
  'extractor.dataProcess.mineru.apiApply.process.tooltip': 'API 申请审核中，请耐心等待',
  'extractor.dataProcess.mineru.apiApply.manage': 'API 管理',

  'mineru.docs.api.token.deleteSuccess': '删除成功',
  'mineru.docs.api.token.name.duplicate': 'API Token 名称不能重复',
  'mineru.docs.api.token.warning': '为了保证您的数据安全，所有 API Tokens 有效期为 14 天，请在过期前更新 API Tokens',
  'mineru.docs.api.token.noPermission': '您尚未获得API管理权限，无法访问此页面。请先申请API权限，待审核通过后重试。',

  'mineru.api.usage': '当前 API 版本：',
  'mineru.api.usage.card.totalPage.title': '累积解析总页数',
  'mineru.api.usage.card.daily.title': '本日页数使用情况',
};
